function addressMultiLineFilter() {
    'ngInject';

    return (address) => {

        if (!address) {
            return;
        }
        if (!address.address1) {
            return;
        }

        let str = '';
        if (address.address1) {
            str += address.address1;
        }
        if (address.address2 && (str.length > 0)) {
            str += '<br/>';
        }
        if (address.address2) {
            str += address.address2;
        }
        if (address.address3 && (str.length > 0)) {
            str += '<br/>';
        }
        if (address.address3) {
            str += address.address3;
        }
        if (address.address4 && (str.length > 0)) {
            str += '<br/>';
        }
        if (address.address4) {
            str += address.address4;
        }
        if (address.address5 && (str.length > 0)) {
            str += '<br/>';
        }
        if (address.address5) {
            str += address.address5;
        }
        if (address.postcode && (str.length > 0)) {
            str += '<br/>';
        }
        if (address.postcode) {
            str += address.postcode;
        }
        return str;
    };
}

angular
    .module('BB')
    .filter('address_multi_line', addressMultiLineFilter);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/address_multi_line.filter.js